export default class NavMobile {
  constructor() {
    this.navIconOpen = document.querySelector('#nav__icon--open');
    this.navIconClose = document.querySelector('#nav__icon--close');
    this.mobileHeader = document.querySelector('.header-main__mobile');
    this.body = document.body;
    this.lastScreenState = this.isSmallScreen();
    
    if (this.navIconOpen && this.navIconClose) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.navIconOpen.addEventListener('click', () => this.openMobileNav());
    this.navIconClose.addEventListener('click', () => this.closeMobileNav());
    
    if (this.mobileHeader) {
      this.mobileHeader.addEventListener('click', (e) => {
        if (e.target === this.mobileHeader) {
          this.closeMobileNav();
        }
      });
    }

    window.addEventListener('resize', () => this.handleResize());
  }

  isSmallScreen() {
    return window.innerWidth < 1280;
  }

  handleResize() {
    const currentScreenState = this.isSmallScreen();
    
    // If screen size crossed the breakpoint
    if (currentScreenState !== this.lastScreenState) {
      this.closeMobileNav();
    } else if (this.mobileHeader?.classList.contains('open')) {
      if (!this.isSmallScreen()) {
        this.body.classList.remove('hidden-scroll');
      } else {
        this.body.classList.add('hidden-scroll');
      }
    }
    
    this.lastScreenState = currentScreenState;
  }

  openMobileNav() {
    if (this.mobileHeader) {
      this.mobileHeader.classList.add('open');
      if (this.isSmallScreen()) {
        this.body.classList.add('hidden-scroll');
      }
    }
  }

  closeMobileNav() {
    if (this.mobileHeader) {
      this.mobileHeader.classList.remove('open');
      this.body.classList.remove('hidden-scroll');
    }
  }
}